const MAX_ACCURACY = 2;

const NutrientConverter = {

  methods: {

    
    unconvertNutrientType(type, active, val) {

      if(val === null) {
        return null;
      }

      const result = this.$store.getters['nutrients/getOriginal'](type, active, val);

      return result;
    },
    
    convertNutrientType(type, active, val) {

      if(val === null) {
        return null;
      }

      const result = this.$store.getters['nutrients/getVal'](type, active, val);
    
      return result;
    }
  }
}

export { NutrientConverter }
